import { isGlobalworth, paths } from 'config'
import { DrawerResources, Resources } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.resources,
    admin: true,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Resources : DrawerResources,
      label: 'nav.resources',
    },
    component: Loadable({
      component: () => import('./pages/Resources'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addResource,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddResource'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.resource,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Resource'),
    }),
    layoutSettings: {},
  },
]

export default routes
